import type { AutoJerryReviewsData } from './parseAutoJerryHtml';

interface GetAutoJerryUpdatedAtParams {
  isLive: boolean;
  reviewsData: AutoJerryReviewsData | null;
  cachedUpdatedAt: string | null;
  hasFetched: boolean;
  fallbackDataDate: string;
}

export const getAutoJerryUpdatedAt = ({
  isLive,
  reviewsData,
  cachedUpdatedAt,
  hasFetched,
  fallbackDataDate,
}: GetAutoJerryUpdatedAtParams): string | null => {
  if (isLive) {
    return null;
  }

  if (reviewsData !== null) {
    return cachedUpdatedAt;
  }

  if (hasFetched) {
    return fallbackDataDate;
  }

  return null;
};
